import React, { memo } from 'react';
import ForcePasswordReset from '../Message/ForcePasswordReset/ForcePasswordReset';
import { Container, FlexStartWrapper } from './Message.styles';
import { CheckmarkIcon, colors, InformationIcon } from '@chegg-ui/theme';
import NoCheggAccount from './NoCheggAccount/NoCheggAccount';
import { LoginErrorsEnum } from '../../lib/constants';
var Message = function Message(props) {
  var type = props.type,
    text = props.text;
  var icon = type === 'error' && /*#__PURE__*/React.createElement(InformationIcon, {
    className: "icon",
    size: "xsmall",
    svgColor: colors.errorRed,
    iconFill: "circlefill"
  }) || /*#__PURE__*/React.createElement(CheckmarkIcon, {
    className: "icon",
    size: "xsmall",
    svgColor: colors.teal,
    iconFill: "circlefill"
  });
  var renderMessage = function renderMessage() {
    switch (text) {
      case LoginErrorsEnum.LOCKED_SUSPICIOUS_ACTIVITY:
        return /*#__PURE__*/React.createElement(FlexStartWrapper, null, icon, /*#__PURE__*/React.createElement(ForcePasswordReset, null));
      case LoginErrorsEnum.NO_CHEGG_ACCOUNT:
        return /*#__PURE__*/React.createElement(FlexStartWrapper, null, icon, /*#__PURE__*/React.createElement(NoCheggAccount, null));
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null, icon, text);
    }
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: type,
    "data-test": "message"
  }, renderMessage());
};
export default /*#__PURE__*/memo(Message);